export default __webpack_public_path__ + "static/media/doctor.8aedf754.png";